/**
 * Siparişin ekranda gösterilecek tutarı. Panel siparişinde (Hayat/Abant) kanal tutarı yalnız
 * tek kalemli ve tam bölünebilen siparişte kaleme yazılır; çok kalemli (19L + koli) ya da
 * kuruşu bölünemeyen (2 × ₺150,005) siparişte `totalAmount` katalog fiyatında kalır, panelin
 * gerçek toplamı `externalProductAmount`'tadır. Hesap yok, yalnız hangi alanın gösterileceği.
 */
export function orderAmount(o: {
  source: string;
  totalAmount: string;
  externalProductAmount?: string | null;
}): string {
  const panel = o.source === 'HAYAT_PANEL' || o.source === 'ABANT_PANEL';
  return panel && o.externalProductAmount ? o.externalProductAmount : o.totalAmount;
}
